export default __webpack_public_path__ + "static/2201-76b31d6b7580faa5b3c8988641b36f48.gif";